import { useCurrentFrame, useVideoConfig, AbsoluteFill } from "remotion";
import { loadFont as loadDev } from "@remotion/google-fonts/NotoSansDevanagari";

const { fontFamily: devFont } = loadDev("normal", { weights: ["700"], subsets: ["devanagari", "latin"] });

interface Word {
  word: string;
  start_ms: number;
  end_ms: number;
  ci: number;
}

export const CreatorCutCaption: React.FC<{ words: Word[]; durationInFrames: number }> = ({ words }) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  if (!words || words.length === 0) return null;

  const currentMs = (frame / fps) * 1000;

  // Find active word — word timing is derived from clip containers so no grace period needed
  let activeIdx = -1;
  for (let i = 0; i < words.length; i++) {
    if (currentMs >= words[i].start_ms && currentMs < words[i].end_ms) {
      activeIdx = i;
      break;
    }
  }

  if (activeIdx < 0) return null;

  // Collect indices of words in the same clip as the active word
  const activeCi = words[activeIdx].ci;
  const clipIndices: number[] = [];
  for (let i = 0; i < words.length; i++) {
    if (words[i].ci === activeCi) clipIndices.push(i);
  }
  const posInClip = clipIndices.indexOf(activeIdx);
  const chunkOffset = Math.floor(posInClip / 3) * 3;
  const chunkIndices = clipIndices.slice(chunkOffset, chunkOffset + 3);
  const chunk = chunkIndices.map(idx => ({ ...words[idx], globalIdx: idx }));

  return (
    <AbsoluteFill style={{ pointerEvents: "none" }}>
      <div style={{
        position: "absolute",
        bottom: "30%",
        left: 0,
        right: 0,
        display: "flex",
        justifyContent: "center",
        padding: "0 28px",
      }}>
        <div style={{
          display: "flex",
          gap: 14,
          alignItems: "baseline",
          flexWrap: "wrap",
          justifyContent: "center",
          maxWidth: "100%",
        }}>
          {chunk.map(({ globalIdx, word }) => (
            <span
              key={globalIdx}
              style={{
                color: globalIdx === activeIdx ? "#FF3B30" : "#ffffff",
                fontSize: 50,
                fontWeight: 700,
                fontFamily: devFont,
                textShadow: "0 2px 12px rgba(0,0,0,1), 0 0 4px rgba(0,0,0,1)",
                lineHeight: 1.3,
              }}
            >
              {word}
            </span>
          ))}
        </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
